import { GitBranch, ListTree, Wrench } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { StepKind } from '@/api/types'

interface StepKindBadgeProps {
  kind: StepKind
  isMilestone?: boolean
  referencedProjectTitle?: string | null
}

const KIND_LABEL: Record<StepKind, string> = {
  ACTION: 'Action',
  SECTION: 'Section',
  PROJECT_REFERENCE: 'Project',
}

export const StepKindBadge = ({
  kind,
  isMilestone,
  referencedProjectTitle,
}: StepKindBadgeProps) => {
  const Icon = kind === 'ACTION' ? Wrench : kind === 'SECTION' ? ListTree : GitBranch
  return (
    <span className="flex items-center gap-1">
      <Badge
        variant="secondary"
        className={cn(
          'gap-1 font-normal uppercase tracking-wide',
          kind === 'PROJECT_REFERENCE' && 'border-primary/40 bg-primary/10 text-primary'
        )}
      >
        <Icon className="h-3 w-3" />
        {kind === 'PROJECT_REFERENCE' && referencedProjectTitle
          ? `From ${referencedProjectTitle}`
          : KIND_LABEL[kind]}
      </Badge>
      {isMilestone && (
        <Badge variant="outline" className="font-normal uppercase tracking-wide">
          Milestone
        </Badge>
      )}
    </span>
  )
}
